import styled from 'styled-components';
import { rgba } from 'polished';
import colors from '../../constants/colors';

const PlaceholderPicture = styled.div`
  background-color: ${rgba(colors.main.black, 0.1)};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 0px;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  min-height: 176px;
`;

export default PlaceholderPicture;
